<template>
  <div class="recharge-container">

    <div v-if="pageLoading" class="skeleton-wrapper">
      <van-skeleton title avatar :row="3" />
      <van-skeleton title :row="3" style="margin-top: 20px" />
    </div>

    <template v-else>
      <div v-if="!kamiCode || initError" class="result-page">
        <van-empty class="custom-empty" image="error" :description="errorMsg || '未获取到有效卡密，请检查链接'">
          <p class="sub-desc">请确认链接是否完整，或联系发卡方核实卡密状态</p>
        </van-empty>
      </div>

      <div v-else class="content-body">
        <div class="header-banner" v-if="rechargeStatus === 'form'">
          <div class="banner-title">流量充值</div>
          <div class="banner-title">信息验证平台</div>
          <div class="banner-subtitle">
            根据运营商要求，流量充值需要验证充值手机号验证码
          </div>
        </div>

        <div v-if="rechargeStatus === 'submitting'" class="result-page">
          <div class="icon-wrap">
            <van-loading type="spinner" size="48" color="#1890ff" />
          </div>
          <h2 class="result-title">充值中</h2>
          <p class="result-desc">正在查询充值结果，请稍候...</p>
          <van-cell-group class="info-group" style="width: 100%; margin-top: 20px !important;" v-if="orderDetail.sporderid">
            <van-cell title="订单编号" :value="orderDetail.sporderid" />
            <van-cell title="产品名称" :value="orderDetail.productName" />
            <van-cell title="充值号码" :value="orderDetail.targetMobile" />
            <van-cell title="充值状态">
              <template #extra>
                <van-tag size="medium" :type="statusTagType(orderDetail.orderStatus)">
                  {{ statusText(orderDetail.orderStatus) }}
                </van-tag>
              </template>
            </van-cell>
          </van-cell-group>
        </div>

        <div v-else-if="rechargeStatus === 'success'" class="result-page">
          <div class="icon-wrap">
            <van-icon name="checked" color="#07c160" size="76" />
          </div>
          <h2 class="result-title">充值成功</h2>
          <p class="result-desc">流量已到账，请留意短信通知或账户余额变动</p>
          <van-cell-group class="info-group" style="width: 100%; margin-top: 20px !important;">
            <van-cell title="订单编号" :value="orderDetail.sporderid" />
            <van-cell title="产品名称" :value="orderDetail.productName" />
            <van-cell title="充值号码" :value="orderDetail.targetMobile" />
            <van-cell title="充值状态">
              <template #extra>
                <van-tag size="medium" type="success">
                  {{ statusText(orderDetail.orderStatus) }}
                </van-tag>
              </template>
            </van-cell>
          </van-cell-group>
          <div class="result-action">
            <van-button type="info" block plain @click="closeWindow">确定</van-button>
          </div>
        </div>

        <div v-else-if="rechargeStatus === 'fail'" class="result-page">
          <div class="icon-wrap">
            <van-icon name="clear" color="#ee0a24" size="76" />
          </div>
          <h2 class="result-title">充值失败</h2>
<!--          <p class="result-desc">{{ failMsg }}</p>-->
          <van-cell-group class="info-group" style="width: 100%; margin-top: 20px !important;" v-if="orderDetail.sporderid">
            <van-cell title="订单编号" :value="orderDetail.sporderid" />
            <van-cell title="产品名称" :value="orderDetail.productName" />
            <van-cell title="充值号码" :value="orderDetail.targetMobile" />
            <van-cell title="充值状态">
              <template #extra>
                <van-tag size="medium" :type="statusTagType(orderDetail.orderStatus)">
                  {{ statusText(orderDetail.orderStatus) }}
                </van-tag>
              </template>
            </van-cell>
            <van-cell title="请联系店铺客服处理!" style="color: #ff4d4f;"></van-cell>
          </van-cell-group>
          <div class="result-action">
            <van-button type="info" block plain @click="closeWindow">确定</van-button>
          </div>
        </div>

        <div v-else-if="rechargeStatus === 'detail'" class="result-page" style="padding-top: 20px;">
          <h2 class="result-title" style="margin-bottom: 20px;">订单详情</h2>
          <van-cell-group class="info-group" style="width: 100%; margin-top: 0 !important;">
            <van-cell title="订单编号" :value="orderDetail.sporderid" />
            <van-cell title="产品名称" :value="orderDetail.productName" />
            <van-cell title="充值号码" :value="orderDetail.targetMobile" />
            <van-cell title="充值状态">
              <template #extra>
                <van-tag size="medium" :type="statusTagType(orderDetail.orderStatus)">
                  {{ statusText(orderDetail.orderStatus) }}
                </van-tag>
              </template>
            </van-cell>
            <van-cell v-if="orderDetail.orderStatus !== 3" title="请联系店铺客服处理!" style="color: #ff4d4f;"></van-cell>
          </van-cell-group>

          <div class="result-action" style="margin-top: 30px;">
<!--            <van-button v-if="orderDetail.orderStatus === 2 || orderDetail.orderStatus === 1"-->
<!--                        type="default" block @click="viewOrder" :loading="detailLoading" style="margin-bottom: 15px;">-->
<!--              刷新最新状态-->
<!--            </van-button>-->
            <van-button type="info" block plain @click="closeWindow">确定</van-button>
          </div>
        </div>

        <template v-else>
          <div class="form-wrapper">
            <div class="product-banner">
              <svg viewBox="0 0 1024 1024" width="20" height="20" style="margin-right: 8px;">
                <path d="M512 0C229.236364 0 0 229.236364 0 512s229.236364 512 512 512 512-229.236364 512-512S794.763636 0 512 0z" fill="#1890ff"></path>
                <path d="M358.4 512c0-84.829091 68.770909-153.6 153.6-153.6s153.6 68.770909 153.6 153.6-68.770909 153.6-153.6 153.6-153.6-68.770909-153.6-153.6z" fill="#ffffff"></path>
                <path d="M512 256c-141.381818 0-256 114.618182-256 256s114.618182 256 256 256 256-114.618182 256-256-114.618182-256-256-256z m0 409.6c-84.829091 0-153.6-68.770909-153.6-153.6s68.770909-153.6 153.6-153.6 153.6 68.770909 153.6 153.6-68.770909 153.6-153.6 153.6z" fill="#66b1ff"></path>
              </svg>
              <span>{{ productInfo.productName || '全国移动1-5GB月包' }}</span>
            </div>

            <van-field v-model="targetMobile" type="tel" maxlength="11" clearable class="custom-field">
              <template #left-icon>
                <van-icon name="phone-o" color="#1890ff" size="20" class="field-icon" />
              </template>
            </van-field>

            <van-field v-model="smsCode" type="digit" maxlength="6" clearable placeholder="请输入验证码" class="custom-field">
              <template #left-icon>
                <van-icon name="passed" color="#1890ff" size="20" class="field-icon" />
              </template>
              <template #button>
                <van-button size="small" type="info" :disabled="smsCountdown > 0 || smsLoading" :loading="smsLoading" @click="sendSmsCode" class="custom-sms-btn">
                  {{ smsCountdown > 0 ? `${smsCountdown}秒` : '获取验证码' }}
                </van-button>
              </template>
            </van-field>

<!--            <div class="red-hint">-->
<!--              可以办理: <span>{{ productInfo.displayPrice ? '¥'+productInfo.displayPrice : '2GB' }}</span>-->
<!--            </div>-->

            <div class="agreement-section">
              <van-checkbox v-model="isAgreed" icon-size="18px" checked-color="#1890ff" shape="round">
                <span class="agreement-text">我已阅读并同意 <span class="policy-link" @click.stop="showPolicy = true">《隐私政策》</span></span>
              </van-checkbox>
            </div>

            <div class="submit-action">
              <van-button type="info" block :loading="submitLoading" loading-text="正在提交..." @click="handleRecharge" class="main-submit-btn">
                立即提交
              </van-button>
            </div>

            <div class="dashed-divider"></div>

            <div class="notice-section">
              <div class="notice-header" @click="showNotice = !showNotice">
                <span>充值须知</span>
                <van-icon :name="showNotice ? 'arrow-up' : 'arrow-down'" color="#c8c9cc" size="14" />
              </div>
              <div class="notice-content" v-show="showNotice">
                <p>1、充值提示成功后，一般到账时间在10分钟内。如遇系统繁忙，充值到账可能存在延迟，建议等待短信通知到账后再使用。</p>
                <p>2、如有其他疑问，详询店铺客服。</p>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>

    <van-dialog v-model="showPolicy" title="隐私政策" confirm-button-color="#1890ff" class="policy-dialog">
      <div class="policy-content">
        <div class="policy-item">
          <div class="policy-text">
            欢迎您使用“流量充值信息验证平台”（以下简称“本平台”）。我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。本《隐私政策》旨在向您说明我们在您使用本平台服务时，如何收集、使用、存储、共享以及保护您的个人信息。<br><br>
            请您在使用本平台提交任何信息前，务必仔细阅读并透彻理解本政策。当您勾选“我已阅读并同意《隐私政策》”并点击提交，即视为您已同意本政策的全部内容。
          </div>
        </div>

        <div class="policy-divider"></div>

        <div class="policy-item">
          <div class="policy-label">1. 我们如何收集您的个人信息</div>
          <div class="policy-text">
            为了向您提供流量直充及信息验证服务，我们需要收集您主动提供的以下个人信息：<br><br>
            <strong>手机号码：</strong>当您在平台进行流量充值时，我们必须收集您的充值手机号码，以便为您精准下发流量套餐。<br><br>
            <strong>短信验证码：</strong>根据通信运营商的安全要求与业务规范，为确保是您本人或授权用户的真实操作，防范恶意充值或欺诈风险，我们需要您输入发送至该手机号的短信验证码进行校验。<br><br>
            <span style="color: #969799; font-size: 13px;">(注：由于本平台为功能专一的 H5 页面，除上述提供核心服务所必需的信息外，我们不会强制收集您的其他非必要个人信息。)</span>
          </div>
        </div>

        <div class="policy-divider"></div>

        <div class="policy-item">
          <div class="policy-label">2. 我们如何使用您的个人信息</div>
          <div class="policy-text">
            我们严格遵守法律法规及与用户的约定，将收集的信息用于以下用途：<br><br>
            <strong>处理充值订单：</strong>将您的手机号码及验证码用于验证操作的真实性，并向对应的通信运营商发起流量直充请求。<br><br>
            <strong>安全防范与客户服务：</strong>用于排查异常订单情况；在您联系客服解决“充值未到账”等售后疑问时，用于核实您的订单详情。
          </div>
        </div>

        <div class="policy-divider"></div>

        <div class="policy-item">
          <div class="policy-label">3. 我们如何共享您的个人信息</div>
          <div class="policy-text">
            为了顺利完成您的流量直充订单，我们必须将您的个人信息与相关第三方进行共享：<br><br>
            <strong>通信运营商（如中国电信、中国移动、中国联通等）：</strong>根据您选择的套餐（如：全国电信流量月包500M直充），我们必须将您的手机号码及验证验证码的指令结果加密传输给对应的通信运营商或其授权的充值接口服务商，以便运营商为您实际划拨流量。<br><br>
            未经您的明示授权，我们不会将您的个人信息出售、出租或违规共享给任何与本服务无关的第三方公司、组织或个人。
          </div>
        </div>

        <div class="policy-divider"></div>

        <div class="policy-item">
          <div class="policy-label">4. 信息的存储与安全</div>
          <div class="policy-text">
            <strong>存储地点：</strong>我们依照法律法规的规定，将收集和产生的个人信息存储于中华人民共和国境内。<br><br>
            <strong>存储期限：</strong>我们仅在为您提供充值服务及后续相关客诉服务期间内保留您的个人信息。超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，除非法律法规另有规定。<br><br>
            <strong>安全措施：</strong>我们采用行业标准的数据传输加密技术（如 HTTPS 协议）和服务器端访问控制机制，尽最大努力防止您的信息被未经授权的访问、泄露、篡改或毁坏。
          </div>
        </div>

        <div class="policy-divider"></div>

        <div class="policy-item">
          <div class="policy-label">5. 您的权利</div>
          <div class="policy-text">
            您对您的个人信息享有以下权利：<br><br>
            <strong>查询与更正：</strong>您可以在操作页面核对您输入的手机号。如输入有误，可在点击“立即提交”前自行修改。<br><br>
            <strong>撤回同意：</strong>如果您不同意本政策，您可以选择不勾选协议并停止使用本平台的提交功能。<br><br>
            <strong>删除信息：</strong>您可以通过联系我们的客服，要求删除您的历史充值订单记录及相关个人信息。
          </div>
        </div>
      </div>
    </van-dialog>

    <van-dialog v-model="showCodeErrorDialog" title="提示" :show-confirm-button="false" :show-cancel-button="false" class="code-error-dialog">
      <div class="code-error-content">
        <van-icon name="warning-o" color="#ee0a24" size="40" style="display: block; margin: 0 auto 12px;" />
        <p class="code-error-text">验证码校验失败，请重新获取验证码</p>
        <div class="code-error-footer">
          <van-button class="cancel-btn" @click="showCodeErrorDialog = false">取消</van-button>
          <van-button type="info" class="resend-btn" @click="handleResendFromError">获取验证码</van-button>
        </div>
      </div>
    </van-dialog>

  </div>
</template>

<script>
import { getKamiDetail, submitRecharge, confirmRechargeSms, getOrderResult } from './api/api';

export default {
  name: 'KamiRecharge',
  filters: {
    formatPrice(val) {
      if (typeof val !== 'number') return '0.00';
      return val.toFixed(2);
    }
  },
  data() {
    return {
      kamiCode: '',
      pageLoading: true,
      initError: false,
      errorMsg: '',

      targetMobile: '',
      smsCode: '',
      isAgreed: false,
      showPolicy: false,

      smsLoading: false,
      smsCountdown: 0,
      timer: null,

      submitLoading: false,
      productInfo: {
        productName: '',
        displayPrice: 0
      },

      rechargeStatus: 'form', // form | submitting | success | fail | detail
      failMsg: '',

      pollingTimer: null,
      pollCount: 0,
      showCodeErrorDialog: false,

      detailLoading: false,
      orderDetail: {
        sporderid: '',
        productName: '',
        targetMobile: '',
        orderStatus: 0,
        failReason: ''
      },
      showNotice: true
    };
  },
  created() {
    console.log('App Created, current path:', window.location.pathname);
    this.initPage();
  },
  destroyed() {
    if (this.timer) clearInterval(this.timer);
    this.stopPolling();
  },
  methods: {
    async initPage() {
      console.log('initPage started');
      // 优先从 query 获取，再从 path 获取
      const urlParams = new URLSearchParams(window.location.search);
      let code = urlParams.get('kamiCode');

      if (!code) {
        // 从路径获取，过滤掉空字符串和 publicPath (h5-client)
        const pathParts = window.location.pathname.split('/').filter(p => p && p !== 'h5-client');
        code = pathParts.pop();
      }

      console.log('Extracted kamiCode:', code);
      this.kamiCode = (this.$route && this.$route.params && this.$route.params.kamiCode) || code;

      this.checkAndResumeCountdown();

      if (!this.kamiCode) {
        this.pageLoading = false;
        return;
      }

      try {
        const res = await getKamiDetail(this.kamiCode);
        const data = res.data || res; // 兼容可能存在的 Axios 拦截器解包
        this.productInfo = data;

        // 根据订单状态决定页面展示：
        // 0(未使用/待充值) / 1(验证码中) → 表单页
        // 2(处理中) → 轮询等待结果
        // 3(成功) → 成功页 + 订单明细
        // 4(失败) / 5(过期) / 6(验证码过期) / 7(已失效) → 失败页 + 订单明细
        const status = data.orderStatus;
        if (status === 0 || status === 1 || !status) {
          this.rechargeStatus = 'form';
        } else if (status === 2) {
          this.orderDetail = {
            sporderid: data.sporderid,
            productName: data.productName,
            targetMobile: data.targetMobile,
            orderStatus: status,
            failReason: data.failReason
          };
          this.rechargeStatus = 'submitting';
          this.$nextTick(() => {
            this.startPolling();
          });
        } else if (status === 3) {
          this.orderDetail = {
            sporderid: data.sporderid,
            productName: data.productName,
            targetMobile: data.targetMobile,
            orderStatus: status,
            failReason: data.failReason
          };
          this.rechargeStatus = 'success';
        } else {
          // status 4 / 5 / 6 / 7
          const failMessages = { 4: '充值失败', 5: '订单已过期', 6: '验证码已过期', 7: '订单已失效' };
          this.orderDetail = {
            sporderid: data.sporderid,
            productName: data.productName,
            targetMobile: data.targetMobile,
            orderStatus: status,
            failReason: data.failReason
          };
          this.rechargeStatus = 'fail';
          this.failMsg = data.failReason || failMessages[status] || '订单异常';
        }

        this.initError = false;
      } catch (error) {
        this.initError = true;
        this.errorMsg = error.message || '卡密无效、不存在或已过期';
      } finally {
        this.pageLoading = false;
      }
    },

    validatePhone() {
      if (!this.targetMobile) {
        this.$toast('请输入充值手机号');
        return false;
      }
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!phoneReg.test(this.targetMobile)) {
        this.$toast('手机号格式不正确，请重新输入');
        return false;
      }
      return true;
    },

    async sendSmsCode() {
      if (!this.validatePhone()) return;

      this.smsLoading = true;
      try {
        await submitRecharge({
          kamiCode: this.kamiCode,
          targetMobile: this.targetMobile
        });
        this.$toast.success('验证码已发送');
        this.startCountdown();
      } catch (error) {
        this.$toast.fail(error.message || '获取验证码失败');
      } finally {
        this.smsLoading = false;
      }
    },

    startCountdown(seconds = 60) {
      this.smsCountdown = seconds;
      const endTime = Date.now() + seconds * 1000;
      localStorage.setItem(`sms_countdown_end_${this.kamiCode}`, endTime);

      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        const remaining = Math.round((endTime - Date.now()) / 1000);
        if (remaining > 0) {
          this.smsCountdown = remaining;
        } else {
          this.smsCountdown = 0;
          localStorage.removeItem(`sms_countdown_end_${this.kamiCode}`);
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },

    checkAndResumeCountdown() {
      const endTime = localStorage.getItem(`sms_countdown_end_${this.kamiCode}`);
      if (endTime) {
        const remaining = Math.round((Number(endTime) - Date.now()) / 1000);
        if (remaining > 0) {
          this.startCountdown(remaining);
        } else {
          localStorage.removeItem(`sms_countdown_end_${this.kamiCode}`);
        }
      }
    },

    async handleRecharge() {
      if (!this.validatePhone()) return;
      if (!this.smsCode) {
        this.$toast('请输入短信验证码');
        return;
      }
      if (!this.isAgreed) {
        this.$toast('请先阅读并同意隐私政策');
        return;
      }

      this.submitLoading = true;
      try {
        await confirmRechargeSms({
          kamiCode: this.kamiCode,
          smsCode: this.smsCode
        });
        // 提交成功，进入轮询状态
        this.rechargeStatus = 'submitting';
        this.startPolling();
      } catch (error) {
        // 验证码错误是软拦截，不应展示为订单失败
        const smsErrorKeywords = ['验证码校验失败，请重新获取验证码', '验证码不正确'];
        const isSmsError = smsErrorKeywords.some(keyword =>
          error.message && error.message.includes(keyword)
        );
        if (isSmsError) {
          // 验证码校验失败，弹窗提示用户重新获取验证码
          this.showCodeErrorDialog = true;
        } else if(error.message === '当前卡密状态不支持提交验证码') {
          this.failMsg = error.message
        } else {
          this.rechargeStatus = 'fail';
          this.failMsg = error.message || '系统繁忙，提单失败请稍后重试';
        }
      } finally {
        this.submitLoading = false;
      }
    },

    retryRecharge() {
      this.rechargeStatus = 'form';
      this.failMsg = '';
      this.smsCode = '';
    },

    // 验证码错误弹窗中点击"获取验证码"
    handleResendFromError() {
      this.showCodeErrorDialog = false;
      // 重置倒计时
      this.smsCountdown = 0;
      this.smsCode = '';
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      localStorage.removeItem(`sms_countdown_end_${this.kamiCode}`);
      // 重新发送验证码
      this.sendSmsCode();
    },

    // 开始轮询订单状态
    startPolling() {
      this.stopPolling();
      this.pollCount = 0;
      const MAX_POLL = 40;      // 最多轮询 40 次
      const INTERVAL = 3000;    // 每 3 秒一次

      const poll = async () => {
        this.pollCount++;

        // 超过最大轮询次数
        if (this.pollCount > MAX_POLL) {
          this.stopPolling();
          if (this.orderDetail.orderStatus === 2) {
            this.$toast('充值处理中，请稍后查看');
          }
          return;
        }

        try {
          const res = await getKamiDetail(this.kamiCode);
          const data = res.data || res;

          // 更新订单明细
          this.orderDetail = {
            sporderid: data.sporderid || '',
            productName: data.productName || '',
            targetMobile: data.targetMobile || '',
            orderStatus: data.orderStatus,
            failReason: data.failReason || ''
          };

          this.handlePollResult(data);
        } catch (error) {
          // 轮询网络异常不中断，继续重试
          console.error('Polling error:', error);
        }
      };

      // 立即执行第一次轮询
      poll();
      // 每 3 秒轮询一次
      this.pollingTimer = setInterval(poll, INTERVAL);
    },

    // 处理轮询结果
    handlePollResult(data) {
      const status = data.orderStatus;
      const failMessages = {
        4: '充值失败',
        5: '订单已过期',
        6: '验证码已过期',
        7: '订单已失效'
      };

      if (status === 3) {
        // 充值成功
        this.stopPolling();
        this.rechargeStatus = 'success';
      } else if (status === 4 || status === 5 || status === 6 || status === 7) {
        // 充值失败 / 已过期 / 验证码过期 / 已失效
        this.stopPolling();
        this.rechargeStatus = 'fail';
        this.failMsg = data.failReason || failMessages[status] || '订单异常';
      }
      // status === 2 (PROCESSING): 继续轮询
    },

    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },

    // 查看订单详情
    async viewOrder() {
      this.detailLoading = true;
      try {
        const res = await getOrderResult(this.kamiCode);
        this.orderDetail = res.data || res; // 兼容不同 axios 拦截器返回层级
        this.rechargeStatus = 'detail';
      } catch (error) {
        this.$toast.fail(error.message || '获取订单详情失败');
      } finally {
        this.detailLoading = false;
      }
    },

    // 状态文本转换
    statusText(status) {
      const map = {
        0: '待充值', // 未使用
        1: '获取验证码中',
        2: '充值中',
        3: '充值成功',
        4: '充值失败',
        5: '已过期',
        6: '验证码过期',
        7: '已失效'
      };
      return map[status] || '未知状态';
    },

    // 状态 Tag 颜色转换
    statusTagType(status) {
      const map = {
        0: 'default',
        1: 'warning',
        2: 'primary',
        3: 'success',
        4: 'danger',
        5: 'default',
        6: 'danger',
        7: 'default'
      };
      return map[status] || 'default';
    },

    closeWindow() {
      window.close();
    }
  }
};
</script>

<style scoped>
/* 背景色改为截图中的浅蓝色到白色的渐变 */
.recharge-container {
  min-height: 100vh;
  background: linear-gradient(180deg, #dcf0ff 0%, #f7f8fa 250px);
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Segoe UI, Arial, Roboto, sans-serif;
  padding-bottom: 20px;
}

/* 顶部蓝色 Banner */
.header-banner {
  background-color: #1890ff;
  padding: 24px;
  color: #ffffff;
}

.banner-title {
  font-size: 32px;
  font-weight: bold;
  line-height: 1.2;
  font-style: italic;
  letter-spacing: 1px;
}

.banner-subtitle {
  font-size: 14px;
  margin-top: 16px;
  opacity: 0.9;
  line-height: 1.5;
  font-weight: 500;
}

/* 核心表单白色卡片 */
.form-wrapper {
  background: #ffffff;
  border-radius: 12px;
  margin: 12px 16px;
  padding: 20px 16px 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
}

/* 顶部蓝色横幅 */
.product-banner {
  background: #eef6ff;
  border: 1px solid #cce4ff;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #1890ff;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 24px;
}

/* 自定义带边框的输入框 */
::v-deep .custom-field {
  border: 1px solid #ebedf0;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

/* 移除vant默认的底边线 */
::v-deep .custom-field::after {
  display: none !important;
}

::v-deep .custom-field .van-field__control {
  font-size: 16px;
}

.field-icon {
  background: #f2f8ff;
  padding: 4px;
  border-radius: 4px;
  margin-right: 8px;
}

/* 获取验证码按钮 */
.custom-sms-btn {
  background-color: #8ab4f8 !important; /* 截图里按钮偏淡蓝 */
  border: none !important;
  color: #ffffff !important;
  font-weight: 500 !important;
  border-radius: 4px;
  width: 90px;
}

/* 红色提示语 */
.red-hint {
  color: #ee0a24;
  font-size: 15px;
  font-weight: bold;
  padding-left: 8px;
  margin-bottom: 20px;
  letter-spacing: 1px;
}

.red-hint span {
  font-size: 16px;
}

/* 协议勾选区 */
.agreement-section {
  padding-left: 8px;
  margin-bottom: 20px;
}

.agreement-text {
  font-size: 14px;
  color: #333;
}

.policy-link {
  color: #1890ff;
}

/* 提交按钮 */
.submit-action {
  margin-bottom: 24px;
}

.main-submit-btn {
  background: #1890ff !important;
  border: none !important;
  height: 44px !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  border-radius: 6px !important;
  letter-spacing: 1px;
}

/* 虚线分割线 */
.dashed-divider {
  border-top: 1px dashed #ebedf0;
  margin: 0 -16px 20px; /* 延伸到卡片边缘 */
}

/* 充值须知 */
.notice-section {
  padding-top: 8px;
}

.notice-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  color: #333;
  margin-bottom: 12px;
  cursor: pointer;
}

.notice-content p {
  font-size: 13px;
  color: #969799;
  line-height: 1.8;
  margin: 0 0 8px 0;
}

/* ================== 下方保留原来的结果页和弹窗样式 ================== */
.skeleton-wrapper { padding: 30px 16px; }
.content-body { position: relative; }
.info-group, .form-group { margin: 0 0 12px !important; box-shadow: none; }
.result-page { display: flex; flex-direction: column; align-items: center; padding: 40px 20px 20px; background-color: transparent; box-sizing: border-box; }
.icon-wrap { margin-top: 20px; margin-bottom: 24px; }
.result-title { font-size: 20px; color: #323233; font-weight: bold; margin: 0 0 12px 0; }
.result-desc { font-size: 15px; color: #646566; margin: 0 0 8px 0; text-align: center; }
.result-sub-desc { font-size: 13px; color: #969799; margin: 0; text-align: center; }
.result-action { width: 100%; margin-top: 40px; padding: 0 16px; box-sizing: border-box; }
.sub-desc { color: #969799; font-size: 13px; margin-top: 8px; }
::v-deep .custom-empty .van-empty__description { color: #323233; font-size: 16px; font-weight: 500; }

::v-deep .policy-dialog { border-radius: 16px; }
::v-deep .policy-dialog .van-dialog__header { padding-top: 24px; font-weight: bold; text-align: left; padding-left: 24px; font-size: 20px; color: #323233; }
.policy-content { padding: 20px 24px; max-height: 60vh; overflow-y: auto; }
.policy-item { margin-bottom: 16px; }
.policy-label { font-size: 15px; color: #646566; margin-bottom: 8px; }
.policy-text { font-size: 15px; color: #323233; line-height: 1.6; }
.policy-divider { height: 1px; background-color: #ebedf0; margin: 16px 0; }

/* 验证码错误弹窗 */
::v-deep .code-error-dialog {
  border-radius: 16px;
}
::v-deep .code-error-dialog .van-dialog__header {
  padding-top: 24px;
  font-weight: bold;
  font-size: 18px;
  color: #323233;
}
.code-error-content {
  padding: 16px 24px 24px;
  text-align: center;
}
.code-error-text {
  font-size: 15px;
  color: #323233;
  line-height: 1.6;
  margin: 0 0 20px;
}
.code-error-footer {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 0 4px;
}
.code-error-footer .cancel-btn {
  flex: 1;
  height: 40px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #dcdee0;
  color: #646566;
}
.code-error-footer .resend-btn {
  flex: 1;
  height: 40px;
  font-size: 14px;
  border-radius: 6px;
  background: #1890ff;
  border: none;
  color: #fff;
}
</style>
